<template>
  <div class="tour-exit">
    <button class="tour-exit__btn" @click="$emit('quit')">
      {{ $t('tours.nav.quit') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'TourExitButton',

  props: {
    stepIndex: { type: Number, required: true },
    totalSteps: { type: Number, required: true }
  }
}
</script>

<style scoped>
.tour-exit {
  position: fixed;
  bottom: 24px;
  /* left: 50%; */
  /* transform: translateX(-50%); */
  left: 120px;
  /* transform: translate(-75%); */
  z-index: 9993;
  pointer-events: auto;
}

.tour-exit__btn {
  padding: 10px 24px;
  background: #fff;
  border: 1.6px solid #6B1F4D;
  border-radius: 8px;
  color: #6B1F4D;
  font-size: 13px;
  font-weight: 500;
  line-height: 1px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: background-color 0.2s ease, color 0.2s ease;
  font-family: 'avenirnext', 'montserrat-regular', Helvetica, Roboto, Arial, sans-serif;
}

.tour-exit__btn:hover {
  background-color: #6B1F4D;
  color: #fff;
}
</style>
